<h1 mat-dialog-title class="text-dark text-xl">
  {{ data.id ? 'Modifica Obiettivo marca' : 'Nuovo Obiettivo marca' }}
</h1>
<div mat-dialog-content class="w-full">
  <app-brand-goals-form [data]="data"></app-brand-goals-form>
</div>
